var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"time-line",style:(_vm.style)},[_vm._v("now")])
}
var staticRenderFns = []

export { render, staticRenderFns }